var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row justify-center" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-4" },
          [
            _c(
              "q-card",
              { staticClass: "q-py-xl bg-white" },
              [
                _c("q-card-title", { staticClass: "text-center login-form" }, [
                  _c("img", { attrs: { src: _vm.login_logo } })
                ]),
                _c("q-card-separator"),
                _c(
                  "q-card-main",
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          helper: _vm.$t(_vm.getPasswordHelper),
                          error: _vm.$v.user_password.$error
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("password"),
                            type: "password",
                            error: _vm.$v.user_password.$error
                          },
                          on: { input: _vm.$v.user_password.$touch },
                          model: {
                            value: _vm.user_password,
                            callback: function($$v) {
                              _vm.user_password = $$v
                            },
                            expression: "user_password"
                          }
                        })
                      ],
                      1
                    ),
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("confirm_password"),
                        type: "password",
                        error: _vm.$v.user_password_confirmation.$error
                      },
                      on: { input: _vm.$v.user_password_confirmation.$touch },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.setNewPassword()
                        }
                      },
                      model: {
                        value: _vm.user_password_confirmation,
                        callback: function($$v) {
                          _vm.user_password_confirmation = $$v
                        },
                        expression: "user_password_confirmation"
                      }
                    }),
                    _c("q-btn", {
                      staticClass: "full-width q-mt-md",
                      attrs: {
                        color: "primary",
                        icon: "fal fa-key",
                        label: _vm.$t(_vm.getLabelButton)
                      },
                      on: {
                        click: function($event) {
                          return _vm.setNewPassword()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("q-card-separator"),
                _c(
                  "q-card-actions",
                  [
                    _c("q-btn", {
                      staticClass: "full-width q-my-sm",
                      attrs: {
                        color: "tertiary",
                        icon: "fas fa-chevron-left",
                        label: _vm.$t("back")
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              _vm.show_error = false
            }
          },
          model: {
            value: _vm.show_error,
            callback: function($$v) {
              _vm.show_error = $$v
            },
            expression: "show_error"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("set_password_error")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("set_new_password_invalid_information")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }